// extracted by mini-css-extract-plugin
export default {"container":"info_container__1tqaw","title":"info_title__3_-rH","description":"info_description__3dH58","message":"info_message__iB9T_"};